<div class="container">
  <h1>Gestión de acceso a APIS</h1>

  <!-- Barra de búsqueda -->
  <div class="search-bar">
    <input
      type="text"
      placeholder="Buscar APIs por nombre, link o descripción"
      [(ngModel)]="searchText"
      (input)="filtrarApis()"
      id="firstInput"
    />
    <input
      type="text"
      placeholder="Introducir Token"
      id="secondInput"
      [class.visible]="showSecondInput"
      [(ngModel)]="key"
      [disabled]="!showSecondInput" 
    />
    <input
      type="text"
      placeholder="Límite de uso"
      id="secondInput"
      [class.visible]="showSecondInput"
      [(ngModel)]="limite_uso"
      [disabled]="!showSecondInput" 
    />

    <!-- Datepicker oculto inicialmente -->
    <mat-form-field appearance="outline" [class.visible]="showSecondInput">
      <mat-label>Fecha de expiración</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [(ngModel)]="expire"
        [disabled]="!showSecondInput" 
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <!-- Botón para guardar token -->
    <button
      class="guardarToken"
      *ngIf="showSecondInput"
      (click)="guardarToken()"
    >
      Guardar Token
    </button>

    <!-- Botón para mostrar/ocultar inputs y datepicker -->
    <button class="verToken" (click)="toggleSecondInput()">
      {{ buttonText }}
    </button>
  </div>
</div>

  <div class="container">
  <!-- Tabla de APIs -->
  <mat-tab-group>
    <mat-tab label="API">
      <div *ngIf="isLoading" class="loading-spinner">
        <mat-spinner></mat-spinner>
      </div>
      <div class="api-table" *ngIf="!isLoading">
        
        <table *ngIf="apisFiltradas.length > 0; else noData">
          <thead>
            <tr>
              <th>API nombre</th>
              <th>Link</th>
              <th>Descripción</th>
              <th>Activo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let api of apisFiltradas">
              <td>{{ api.nombre }}</td>
              <td class="link-cell"><a>{{ api.link }}</a></td>
              <td class="descrip">{{ api.descripcion }}</td>
              <td>
                <mat-slide-toggle
                  [checked]="api.active"
                  (change)="onToggleChange(api)"
                  class="custom-toggle"
                >
                </mat-slide-toggle>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #noData>
          <p>No hay APIs disponibles.</p>
        </ng-template>
      </div>
    </mat-tab>
    <mat-tab label="Historial de consultas" [disabled]="true"></mat-tab>
  </mat-tab-group>
  
</div>